<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <div class="modal-row two-columns">
            <div class="column">
              <label>年度标志</label>
            </div>
            <div class="column">
              <el-input 
                v-model="localMilestoneInfo.year" 
                placeholder="请输入年度标志"
              ></el-input>
            </div>
          </div>
          
          <div class="modal-row">
            <el-input
              type="textarea"
              v-model="localMilestoneInfo.descInfo"
              placeholder="请输入年度计事"
              :rows="5"
            ></el-input>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>状态管理</label>
            </div>
            <div class="column">
              <select v-model="localMilestoneInfo.status" class="status-select">
                <option value="0">正常</option>
                <option value="1">禁用</option>
              </select>
            </div>
          </div>
          
          <!-- 第四行：操作按钮 -->
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';

import { saveMilestoneInfo } from '@/api/milestone';

export default {
  name: 'CreateMilestoneInfo',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    MilestoneInfo: {
      type: Object,
      default: () => ({
        id: null,
        year: '',
        descInfo: '',
        status: ''
      })
    }
  },
  data() {
    return {
      localMilestoneInfo: {
        ...this.MilestoneInfo
      }
    }
  },
  mounted() {
    // this.CatchPhraseInfo = this.props.CatchPhraseInfo
  },
  methods: {
    clearForm() {
      this.localMilestoneInfo = {}
    },
    closeModal() {
      this.clearForm();
      this.isVisible = !this.isVisible;
      this.$emit('update:visible', false);
    },
    async submitForm() {
      // 2. 添加 MilestoneInfo 对象（转换为JSON字符串）
      const MilestoneInfo = {
        id: this.localMilestoneInfo.id,
        year: this.localMilestoneInfo.year,
        descInfo: this.localMilestoneInfo.descInfo,
        status: this.localMilestoneInfo.status
      }
      
      try {
        const resp = await saveMilestoneInfo(MilestoneInfo);
        if (resp.code === 200 && resp.success) {
          Message.success('操作成功！');
          this.$emit('saved', resp.data);
          this.closeModal();
        } else {
          Message.error(resp.msg || '操作失败');
        }
      } catch (error) {
        Message.error('请求失败: ' + error.msg);
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opaMilestone 0.3s ease;
}

@media(max-width: 768px){
.modal-container {
  width: 90% !important;
  padding: 6px !important;
}
}

.modal-container {
  width: 50%;
  min-height: 60%;
    /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.6);
  /* 提高透明度 */
  backdrop-filter: blur(16px) saturate(180%);
  /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
  margin-bottom: 20px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.column:first-child {
  margin-right: 15px;
  min-width: 100px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>